module.exports = __webpack_public_path__ + "static/media/advantage-1.bd65b648.png";